import { Filter } from 'common/repositories/common.model';
import React from 'react';

interface UseSetDefaultFiltersProps {
  setFilters: React.Dispatch<React.SetStateAction<Filter[] | undefined>>;
  values: { name: string; value: string | undefined }[];
  filters: Filter[];
}

export default function useSetDefaultFilters(props: UseSetDefaultFiltersProps) {
  const { filters, setFilters, values } = props;
  const [initiate, setInitiate] = React.useState(false);

  React.useEffect(() => {
    if (initiate) return;
    if (filters.length === 0) return;
    if (values.length === 0) return;
    setFilters(() => {
      const _filters = filters?.map((filter) => {
        const matchesFilters = values?.find(
          (curr) => curr.name === filter.name,
        );

        if (matchesFilters) {
          filter.value = matchesFilters.value;
        }

        return filter;
      });

      return _filters;
    });
    setInitiate(true);
  }, [filters, filters?.length, initiate, setFilters, values]);
}
